/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React, {useContext, useEffect, useState} from 'react';
import {Outlet, useNavigate} from "react-router-dom";

import {AppNavigator, getJwt, Loader, setJwt} from '@dvrd/dvr-controls';

import './util/startup';
import {PopupController} from "./components/misc/popupController";
import User from "./models/userModel";
import {AppContext} from "./components/misc/appContext";

export default function App() {
    const context = useContext(AppContext);
    const [validatingUser, setValidatingUser] = useState(false);
    const navigate = useNavigate();

    function validateUser() {
        if (getJwt()) {
            User.get((user: User | null, success: boolean) => {
                if (success) {
                    context.onChangeContext({user}, startApplication)
                } else setJwt(null);
            });
        } else
            setValidatingUser(false);
    }

    function startApplication() {
        setValidatingUser(false);
        if (window.location.pathname.includes('inloggen'))
            window.setTimeout(() => {
                // Set a timeout to make sure the navigator is loaded correctly, before navigating.
                navigate('/downloader');
            }, 0);
    }

    useEffect(() => {
        validateUser();
    }, []);

    if (validatingUser) return <Loader active/>
    return (
        <>
            <AppNavigator/>
            <div className='page'>
                <Outlet/>
            </div>
            <PopupController/>
        </>
    )
}